import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { useExpertMessageReviewContext } from "../../../hooks/expert-message-review/ExpertMessageReviewContext";
import { validateEscalationReview } from "../../../utils/validators/MessageReviewValidator";
const DEFAULT_ESCALATION_SUMMARY_LABEL = "You're undecided";
const ExpertEscalationReviewSummary = ({
  children
}) => {
  const {
    message,
    messageReviewDetails,
    updateEscalationVote,
    submitReviewData,
    resetReviewState,
    switchToReview
  } = useExpertMessageReviewContext();
  const escalationDialogue = React.useMemo(() => {
    //find the latest escalation dialogue, from the bottom of the list
    const messageDialogues = [...message.dialogues];
    return messageDialogues.reverse().find(dialogue => dialogue.type === "escalation");
  });
  const handleReviewCompleted = () => {
    submitReviewData();
  };
  const handleEscalationAgree = () => {
    updateEscalationVote(escalationDialogue.dialogueId, true);
  };
  const onEscalationDisagree = () => {
    updateEscalationVote(escalationDialogue.dialogueId, false);
  };
  let reviewState = "";
  if (Object.keys(messageReviewDetails.escalation).length === 1) {
    reviewState = messageReviewDetails.escalation[escalationDialogue.dialogueId];
  }
  const {
    isCancelDisabled,
    isFinishDisabled
  } = validateEscalationReview(messageReviewDetails, reviewState, message.reviewRequiredVotingExperts);
  return children({
    switchToReview,
    resetReviewState,
    isCancelDisabled,
    isFinishDisabled,
    escalationReviewState: reviewState,
    onEscalationAgree: handleEscalationAgree,
    onEscalationDisagree,
    defaultSummaryLabel: DEFAULT_ESCALATION_SUMMARY_LABEL,
    onFormSubmit: handleReviewCompleted,
    noOfDialoguesVoted: Object.keys(messageReviewDetails.dialogues).length
  });
};
export default ExpertEscalationReviewSummary;
ExpertEscalationReviewSummary.propTypes = {
  children: PropTypes.func.isRequired
};